import React, { useEffect } from "react";

const About = () => {

   useEffect(() => {
          const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const scrollY = window.scrollY;
      
            const animatables = document.querySelectorAll('.animatable');
      
            animatables.forEach(animatable => {
              const elementTop = animatable.getBoundingClientRect().top + scrollY;
              const elementBottom = elementTop + animatable.clientHeight;
      
              // Check if element is in the viewport
              if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
                animatable.classList.add('animated');
                animatable.classList.remove('animatable');
              } else {
                // Reset the animation when the element is out of view
                animatable.classList.remove('animated');
                animatable.classList.add('animatable');
              }
            });
          };
      
          window.addEventListener('scroll', handleScroll);
          handleScroll(); // Trigger animation on mount
      
          return () => {
            window.removeEventListener('scroll', handleScroll);
          };
        }, []);


  return (
    <div className="about-us-container">
      <section className="about-section">
        <h1 className="about-title block animatable bounceInLeft">Where Education Meets Excellence</h1>
        <p className="about-content block animatable bounceInRight">
          At Shiva Ganga Group, we believe in shaping young minds to become the leaders of tomorrow. Founded under the visionary leadership of Mr. Thota Shiva Kumar, our society is rooted in a mission to deliver transformative education through a network of prestigious institutions. Each institution under our umbrella is dedicated to fostering an environment that encourages curiosity, critical thinking, and holistic growth. Our journey is a testament to the power of education in building a progressive and inclusive society.
        </p>
      </section>

      <section className="journey-section">
        <h2 className="journey-title block animatable bounceInLeft">Our Journey</h2>
        <ul className="journey-list block animatable bounceInRight">
          <li>2014: Inaugurated GD Goenka School Hyderabad, a premier CBSE institution known for its state-of-the-art infrastructure and focus on innovation in education.</li>
          <li>2018: Launched the first Aekaksh School at LB Nagar, emphasizing personalized learning and early childhood development.</li>
          <li>2021: Expanded with two additional branches of Aekaksh Schools at Himayath Nagar and Punjagutta to cater to the growing demand for quality education.</li>
          <li>2023: Introduced Soul Sportza, a dedicated sports academy focusing on physical fitness and professional sports training.</li>
        </ul>
      </section>

      <section className="core-beliefs-section">
        <h2 className="core-beliefs-title block animatable bounceInLeft">Core Beliefs and Values</h2>
        <ul className="core-beliefs-list block animatable bounceInRight">
          <li>Excellence in Education: Striving to provide the best academic, extracurricular, and co-curricular experiences.</li>
          <li>Innovation: Staying ahead by integrating modern teaching methodologies and technology-driven solutions.</li>
          <li>Holistic Development: Balancing academics, sports, and life skills to nurture well-rounded individuals.</li>
          <li>Inclusivity: Welcoming diversity and promoting equality in education.</li>
          <li>Community Engagement: Creating a strong bond with parents and society to build a collaborative education system.</li>
        </ul>
      </section>

      <section className="leadership-section">
        <h2 className="leadership-title block animatable bounceInLeft">Leadership Messages</h2>
        <div className="leadership-message">
          <div>
          <img
            src="./images/Chairman.png"
            alt="Chairman"
            className="main-hm-img"
          />
          <h3 className="message-title block animatable bounceInLeft">Chairman’s Vision</h3>
          </div>
          <p className="message-content block animatable bounceInRight">
            "Education must prepare students for the unpredictable challenges of the future. At Shiva Ganga Group, we aim to create institutions where students not only excel academically but also grow into empathetic and responsible citizens."
            – Thota Shiva Kumar, Chairman
          </p>
        </div>
        {/* <div className="leadership-message">
          <div>
          <img
            src="./images/Director.png"
            alt="Director"
            className="main-hm-img"
          />
          <h3 className="message-title block animatable bounceInLeft">Director’s Inspiration</h3>
          </div>
          <p className="message-content">
            "Children are the architects of tomorrow. We focus on unlocking their true potential by providing a nurturing and stimulating environment. Our goal is to foster creativity, confidence, and competence in every child."
            – Thota Nivedita, Director
          </p>
        </div> */}
      </section>

      <section className="institutions-section">
        <h2 className="institutions-title block animatable bounceInLeft">Our Institutions</h2>
        <ul className="institutions-list block animatable bounceInRight">
          <li>GD Goenka School Hyderabad: Combining global education standards with Indian values.</li>
          <li>Aekaksh Schools: Centers of personalized and foundational learning for young minds.</li>
          <li>Soul Sportza: A sports academy designed to cultivate discipline, teamwork, and a winning spirit.</li>
        </ul>
      </section>
    </div>
  );
};

export default About;
